<ion-card-content class="progress-wrapper">
  <div class="progress-header">
    <span class="title">Разобранный вес по заявке</span>
  </div>
  <div class="progress-step">
    <div class="start">0<span class="ton-symbol">т</span></div>
    <div class="finish">{{ totalWeight }}<span class="ton-symbol">т</span></div>
  </div>
  <ion-progress-bar [value]="progress"></ion-progress-bar>

  <div class="progress-footer">
    <span>Разобрано: <b style="color: #00BFA8">{{ assignedWeight }}</b> <span class="ton-symbol">т</span></span>
    <span>Осталось разобрать: <b>{{ remainingWeight }}</b> <span class="ton-symbol">т</span></span>
  </div>
</ion-card-content>
